// Filter for Next.js' own control-flow errors — the framework throws these to
// signal bailouts (dynamic rendering, redirect, notFound), not real failures.
// Capturing them in PostHog buries real bugs under noise.
//
// Shared between `instrumentation.ts` (guards `onRequestError`) and
// `lib/logger.ts` (guards the `logger.error` → PostHog dual-dispatch path).
// Without the latter, any `try { ... await cookies() ... } catch (e) {
// logger.error(...) }` site re-emits the bailout signal through the shim.

const NEXT_CONTROL_FLOW_DIGEST_PREFIXES = [
  "NEXT_HTTP_ERROR_FALLBACK",
  "NEXT_REDIRECT",
  "NEXT_NOT_FOUND",
  "DYNAMIC_SERVER_USAGE",
];

interface NextControlFlowLike {
  digest?: unknown;
  message?: unknown;
}

export function isNextControlFlow(error: unknown): boolean {
  if (error == null || typeof error !== "object") return false;
  const err = error as NextControlFlowLike;
  if (typeof err.digest === "string") {
    for (const prefix of NEXT_CONTROL_FLOW_DIGEST_PREFIXES) {
      if (err.digest.startsWith(prefix)) return true;
    }
  }
  if (typeof err.message === "string") {
    if (err.message.startsWith("Dynamic server usage:")) return true;
    if (err.message === "NEXT_HTTP_ERROR_FALLBACK;404") return true;
    if (err.message === "NEXT_REDIRECT") return true;
  }
  return false;
}
